import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../App';
import { toast } from 'sonner';

export default function SetupPassword({ onLogin }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      toast.error('Invalid invitation link');
      navigate('/login');
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      toast.error('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/setup-password', { token, password });
      toast.success('Account set up successfully!');
      onLogin(response.data.user, response.data.access_token);
      navigate('/');
    } catch (err) {
      const message = err.response?.data?.detail || 'Failed to set up account';
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="setup-password-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Set Up Your Account</h1>
          <p>Create a password to access Unit Relay</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit} data-testid="setup-form">
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              data-testid="password-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirm your password"
              data-testid="confirm-password-input"
            />
          </div>

          {error && <div className="error-message" data-testid="error-message">{error}</div>}

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="submit-button"
          >
            {loading ? 'Setting up...' : 'Complete Setup'}
          </button>
        </form>
      </div>
    </div>
  );
}
